import { getAltParts } from "./Wrapper"

const dNumber = [
    'D11002012',
    'D11000047',
    'D11021236',
    'D11001483',
    'D11002010',
    'D11000168',
    'D11000038',
    'D11000649',
    'D11000045',
    'D11000064',
    'D11007415',
    'D11007714',
    'D11000757',
    'D11017543',
    'D11001038',
    'D11000985',
    'D11008010',
    'D11001021',
    'D11000181',
    'D11007430',
    'D11025888',
    'D11007618',
    'D11007948',
    'D11000382',
    'D11000747',
    'D11002673',
    'D11026161',
    'D11001225',
    'D11000016',
    'D11008728',
    'D11018158',
    'D11002670',
    'D11001936',
    'D11018867',
    'D11002005',
    'D11002537',
    'D11015777',
    'D11000728',
    'D11001979',
    'D11007436',
    'D11007433',
    'D11001022',
    'D11002371',
    'D11000719',
    'D11002427',
    'D11019673',
    'D11000162',
    'D11000648',
    'D11000030',
    'D11000890',
    'D11000040',
    'D11002683',
    'D11019672',
    'D11007844',
    'D11002536',
    'D11000096',
    'D11007377',
    'D11007417',
    'D11022983',
    'D11002435',
    'D11001750',
    'D11008258',
    'D11020776',
    'D11000245',
    'D11000744',
    'D11002534',
    'D11002185',
    'D11003498',
    'D11007445',
    'D11000537',
    'D11001978',
    'D11009671',
    'D11000385',
    'D11025595',
    'D11000535',
    'D11000581',
    'D11001870',
    'D11002016',
    'D11009008',
    'D11023951',
    'D11001869',
    'D11002044',
    'D11000542',
    'D11002540',
    'D11023739',
    'D11000727',
    'D11000007',
    'D11001154',
    'D11001612',
    'D11001756',
    'D11002319',
    'D11000097',
    'D11000629',
    'D11000714',
    'D11000961',
    'D11007965',
    'D11022874',
    'D11001300',
    'D11002568',
    'D11002815',
    'D11000069',
    'D11002535',
    'D11008298',
    'D11010961',
    'D11001524',
    'D11002545',
    'D11000596',
    'D11002642',
    'D11005889',
    'D11020882',
    'D11002546',
    'D11007421',
    'D11014539',
    'D11024260',
    'D11025748',
    'D11007371',
    'D11007438',
    'D11009644',
    'D11014448',
    'D11025494',
    'D11025806',
    'D11000497',
    'D11000639',
    'D11000718',
    'D11001322',
    'D11004345',
    'D11005401',
    'D11010925',
    'D11002541',
    'D11002737',
    'D11007541',
    'D11007937',
    'D11014677',
    'D11019559',
    'D11000658',
    'D11000697',
    'D11001795',
    'D11007640',
    'D11008502',
    'D11008978',
    'D11020217',
    'D11002098',
    'D11002987',
    'D11007968',
    'D11015908',
    'D11019576',
    'D11000076',
    'D11000367',
    'D11000437',
    'D11000469',
    'D11001297',
    'D11002334',
    'D11002428',
    'D11007530',
    'D11011560',
    'D11024604',
    'D11025453',
    'D11000640',
    'D11001921',
    'D11012894',
    'D11016696',
    'D11022982',
    'D11000031',
    'D11008107',
    'D11010811',
    'D11000289',
    'D11000683',
    'D11000711',
    'D11001816',
    'D11002566',
    'D11018503',
    'D11026676',
    'D11000103',
    'D11000315',
    'D11000546',
    'D11000636',
    'D11002131',
    'D11002629',
    'D11000087',
    'D11000139',
    'D11000149',
    'D11001656',
    'D11001815',
    'D11001885',
    'D11002787',
    'D11007816',
    'D11007946',
    'D11020965',
    'D11031057',
    'D11000104',
    'D11001773',
    'D11005037',
    'D11007325',
    'D11007771',
    'D11007962',
    'D11015662',
    'D11017840',
    'D11000760',
    'D11002544',
    'D11005275',
    'D11007932',
    'D11008068',
    'D11012243',
    'D11014246',
    'D11019722',
    'D11021195',
    'D11000799',
    'D11002654',
    'D11002915',
    'D11007738',
    'D11015525',
    'D11017395',
    'D11000051',
    'D11000745',
    'D11000962',
    'D11001315',
    'D11001775',
    'D11003193',
    'D11003200',
    'D11009092',
    'D11010318',
    'D11014046',
    'D11025889',
    'D11000963',
    'D11002603',
    'D11002617',
    'D11002648',
    'D11007435',
    'D11007437',
    'D11010790',
    'D11017724',
    'D11026735',
    'D11036928',
    'D11000256',
    'D11000577',
    'D11001419',
    'D11001758',
    'D11001850',
    'D11002073',
    'D11003095',
    'D11007422',
    'D11007929',
    'D11008308',
    'D11008656',
    'D11009166',
    'D11016056',
    'D11024409',
    'D11026566',
    'D11000032',
    'D11000059',
    'D11000112',
    'D11000354',
    'D11002436',
    'D11007477',
    'D11010143',
    'D11000688',
    'D11000784',
    'D11002586',
    'D11002724',
    'D11003577',
    'D11009009',
    'D11011559',
    'D11012057',
    'D11014547',
    'D11014650',
    'D11015660',
    'D11016984',
    'D11018533',
    'D11019117',
    'D11020292',
    'D11000234',
    'D11000776',
    'D11001123',
    'D11002315',
    'D11006154',
    'D11007333',
    'D11007339',
    'D11007359',
    'D11007555',
    'D11007910',
    'D11008977',
    'D11009015',
    'D11014021',
    'D11014676',
    'D11014762',
    'D11015452',
    'D11015599',
    'D11016386',
    'D11018159',
    'D11025591',
    'D11000001',
    'D11000210',
    'D11000850',
    'D11002028',
    'D11002766',
    'D11006077',
    'D11007352',
    'D11007545',
    'D11010040',
    'D11015524',
    'D11023051',
    'D11000020',
    'D11000286',
    'D11000332',
    'D11000851',
    'D11001471',
    'D11001891',
    'D11001938',
    'D11002601',
    'D11007634',
    'D11007865',
    'D11010386',
    'D11010865',
    'D11016935',
    'D11022188',
    'D11037698',
    'D11038683',
    'D11000105',
    'D11000837',
    'D11002042',
    'D11002433',
    'D11002555',
    'D11002620',
    'D11002744',
    'D11005758',
    'D11007354',
    'D11007478',
    'D11008295',
    'D11008921',
    'D11014617',
    'D11018302',
    'D11023116',
    'D11000209',
    'D11000499',
    'D11000538',
    'D11000687',
    'D11001177',
    'D11001499',
    'D11002798',
    'D11003090',
    'D11007446',
    'D11007479',
    'D11007976',
    'D11011239',
    'D11018039',
    'D11021147',
    'D11023291',
    'D11025085',
    'D11040041',
    'D11000428',
    'D11000833',
    'D11002186',
    'D11002539',
    'D11002571',
    'D11002736',
    'D11004329',
    'D11007941',
    'D11008299',
    'D11008779',
    'D11009026',
    'D11014415',
    'D11017817',
    'D11021822',
    'D11023061',
    'D11023233',
    'D11023262',
    'D11000033',
    'D11000093',
    'D11000119',
    'D11000637',
    'D11001111',
    'D11002560',
    'D11002856',
    'D11004015',
    'D11004069',
    'D11007370',
    'D11007547',
    'D11007560',
    'D11007739',
    'D11007740',
    'D11010810',
    'D11014492',
    'D11019898',
    'D11021145',
    'D11021475',
    'D11026198',
    'D11026565',
    'D11000052',
    'D11000524',
    'D11000532',
    'D11000568',
    'D11000983',
    'D11001309',
    'D11001598',
    'D11002694',
    'D11002712',
    'D11003144',
    'D11007440',
    'D11007871',
    'D11007914',
    'D11008489',
    'D11008973',
    'D11009018',
    'D11009137',
    'D11011253',
    'D11013680',
    'D11014540',
    'D11014870',
    'D11016669',
    'D11018998',
    'D11026843',
    'D11000126',
    'D11000433',
    'D11001222',
    'D11001345',
    'D11001772',
    'D11001781',
    'D11002231',
    'D11002397',
    'D11002553',
    'D11002666',
    'D11003068',
    'D11004037',
    'D11007629',
    'D11007973',
    'D11007995',
    'D11008257',
    'D11008966',
    'D11010307',
    'D11011464',
    'D11014163',
    'D11016004',
    'D11016153',
    'D11018347',
    'D11018471',
    'D11024239',
    'D11027192',
    'D11038684',
    'D11000073',
    'D11000154',
    'D11000374',
    'D11000458',
    'D11000681',
    'D11000786',
    'D11001506',
    'D11001783',
    'D11002464',
    'D11002734',
    'D11002878',
    'D11003781',
    'D11004264',
    'D11007434',
    'D11007469',
    'D11007496',
    'D11008080',
    'D11010277',
    'D11011593',
    'D11013601',
    'D11013984',
    'D11014553',
    'D11016355',
    'D11016487',
    'D11016521',
    'D11017833',
    'D11018100',
    'D11018133',
    'D11021422',
    'D11022088',
    'D11022194',
    'D11022195',
    'D11025167',
    'D11026719',
    'D11029020',
    'D11044952',
    'D11000092',
    'D11000166',
    'D11000175',
    'D11000214',
    'D11000480',
    'D11000487',
    'D11000493',
    'D11000762',
    'D11001239',
    'D11001872',
    'D11002058',
    'D11002100',
    'D11002144',
    'D11002200',
    'D11002533',
    'D11002543',
    'D11003066',
    'D11003088',
    'D11003179',
    'D11007363',
    'D11007460',
    'D11008388',
    'D11008459',
    'D11008473',
    'D11008620',
    'D11008665',
    'D11010158',
    'D11010279',
    'D11010989',
    'D11013639',
    'D11014162',
    'D11015729',
    'D11015793',
    'D11016390',
    'D11017276',
    'D11019619',
    'D11020683',
    'D11021274',
    'D11026606',
    'D11026835',
    'D11027200',
    'D11027557',
    'D11028243',
    'D11029688',
    'D11030046'

]
import { getPartFromDNumber, getASWOPartsFromPart, getConnectPartsFromPart } from './Wrapper.js'

export async function d8ToMan() {
    // const promises = []
    // dNumber.forEach(number => {
    //     promises.push(

    //     )
    // })
    // const manufactureCodePromises = []
    // const parts = await Promise.all(promises)
    const allParts = []
    const start = async () => {

        await asyncForEach(dNumber, (async (dpart, index) => {
            await waitFor(50);
            if (index < 1000) {
                await getPartFromDNumber(dpart).then(async dtosup => {
                    if (dtosup != "No C or D Number") {
                        if (dtosup.length > 12) {
                            //getConnectPart
                            // await getConnectPartsFromPart(dtosup).then(async connectPart => {
                            //     const part = [dpart,
                            //         dtosup,
                            //         connectPart[0] != undefined ? connectPart[0].fullManufactureCode : "",
                            //         connectPart[0] != undefined ? connectPart[0].brand : "",
                            //         connectPart[0] != undefined ? connectPart[0].unitPrice : ""
                            //     ]
                            //     console.log(part);
                            //     allParts.push(part)
                            //     await waitFor(50);
                            // })

                        } else if (dtosup.length < 12) {
                            //getAswoPart
                            await getASWOPartsFromPart(dtosup).then(async aswoPart => {
                                const part = [dpart,
                                    dtosup,
                                    aswoPart[0] != undefined ? aswoPart[0].fullManufactureCode : "",
                                    aswoPart[0] != undefined ? aswoPart[0].brand : "",
                                    aswoPart[0] != undefined ? aswoPart[0].unitPrice : ""
                                ]
                                console.log(part);
                                allParts.push(part)
                                await waitFor(50);
                            })
                        }

                    }

                })
            }

        })

        )
        return allParts
    }
    start().then(parts => { console.log("Parts", [...parts]); })






}
async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}
const waitFor = (ms) => new Promise(r => setTimeout(r, ms));